import React, { memo } from "react";

import { Grid } from "@mui/material";

import {
  normalizeRRDPrintTypeContext,
  supportsRRDDifferentExpiry,
} from "@/features/campaigns/direct-mail/rrd/utils/rrdLayoutHelper";
import RRDDirectBackCouponExpInput from "../common/rrdInputFields/RRDDirectBackCouponExpInput";
import RRDDirectDifferentExpToggleInput from "../common/rrdInputFields/RRDDirectDifferentExpToggleInput";
import RRDDirectFrontCouponExpInput from "../common/rrdInputFields/RRDDirectFrontCouponExpInput";

type RRDLocationCouponExpiryProps = {
  locationId: string | number;
  printType?: string;
  layoutKey?: string;
  expiryDateConstraints?: Record<string, any>;
  minCouponDurationAdmin?: number | string | null;
  couponExpirationSetBy?: string;
  fixedCouponDurationDays?: number | string | null;
};

function RRDLocationCouponExpiry({
  locationId,
  printType,
  layoutKey,
  expiryDateConstraints,
  minCouponDurationAdmin,
  couponExpirationSetBy,
  fixedCouponDurationDays,
}: RRDLocationCouponExpiryProps) {
  const context = normalizeRRDPrintTypeContext({
    print_type: printType,
    layoutKey,
  });

  return (
    <div>
      {couponExpirationSetBy !== "brand" &&
        supportsRRDDifferentExpiry(context.layoutKey) && (
          <RRDDirectDifferentExpToggleInput
            name={`${locationId}.different_coupon_expiry`}
            mailingDateFieldName={`${locationId}.mailing_date`}
            backCouponExpiryFieldName={`${locationId}.back_coupon_expiry_date`}
            expiryDateConstraints={expiryDateConstraints}
          />
        )}

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <RRDDirectFrontCouponExpInput
            name={`${locationId}.front_coupon_expiry_date`}
            mailingDateFieldName={`${locationId}.mailing_date`}
            differentCouponExpiryFieldName={`${locationId}.different_coupon_expiry`}
            containerClassName="rrd-coupon-expiry-input"
            expiryDateConstraints={expiryDateConstraints}
            minCouponDurationDays={minCouponDurationAdmin}
            couponExpirationSetBy={couponExpirationSetBy}
            fixedCouponDurationDays={fixedCouponDurationDays}
          />
        </Grid>
        {couponExpirationSetBy !== "brand" ? (
          <Grid size={{ xs: 12, md: 6 }}>
            <RRDDirectBackCouponExpInput
              name={`${locationId}.back_coupon_expiry_date`}
              mailingDateFieldName={`${locationId}.mailing_date`}
              differentCouponExpiryFieldName={`${locationId}.different_coupon_expiry`}
              containerClassName="rrd-coupon-expiry-input"
              expiryDateConstraints={expiryDateConstraints}
            />
          </Grid>
        ) : null}
      </Grid>
    </div>
  );
}

export default memo(RRDLocationCouponExpiry);
